//disable-sort-imports
//@ts-nocheck TODO: fix it
import { ProductFiltersInterface, ActiveFiltersInterface } from '../../interfaces/FiltersInterface'
import _ from 'lodash'
import qs from 'qs'
import BigNumber from 'bignumber.js'
import { AVAILABLE_FILTERS, FILTER_FLAT } from './productFilterConstants'

const parseFilters = (params: ProductFiltersInterface) => {
  const result: ActiveFiltersInterface = {} as ActiveFiltersInterface

  for (const filterKey in AVAILABLE_FILTERS) {
    if (filterKey in params) {
      const availableKeys = AVAILABLE_FILTERS[filterKey]
      const param = params[filterKey]

      if (_.isArray(availableKeys)) {
        if (availableKeys.length > 0) {
          result[filterKey] = {}

          for (const availableKey of availableKeys) {
            if (availableKey in param) {
              result[filterKey][availableKey] = param[availableKey]
            }
          }
        } else {
          result[filterKey] = []

          for (const key in param) {
            result[filterKey].push(param[key])
          }
        }
      } else if (_.isObject(availableKeys)) {
        result[filterKey] = param
      }
    }
  }

  return result
}

export const loadFiltersFromQueryParams = (queryParams: string) => {
  const params = qs.parse(queryParams, { ignoreQueryPrefix: true, parseArrays: false })
  return parseFilters(params)
}

export const getAttributesHtml = (filters: ProductFiltersInterface) =>
  filters?.attributes?.filter(item => item.visible).sort((a, b) => a.position - b.position)

export const isFlatAttributeChecked = (activeFilters: ActiveFiltersInterface, name: string, id: number | string) => {
  return name in activeFilters && activeFilters[name] && activeFilters[name].find((itemId: string) => itemId == id) !== undefined
}

export const isAttributeChecked = (activeFilters: ActiveFiltersInterface, attributeId: number, valueId: number) => {
  if (!_.has(activeFilters, `attributes.${attributeId}.${valueId}`)) {
    return false
  }
  /// @ts-ignore
  const value = parseInt(activeFilters['attributes'][attributeId][valueId], 10)
  return Number.isNaN(value) || value > 0
}

export const getFlatFilters = (params: string) => {
  const flatFilters: ActiveFiltersInterface = loadFiltersFromQueryParams(params)
  if (_.isObject(flatFilters.attributes)) {
    const newFilters = Object.keys(flatFilters.attributes)
      .map(attributeId => {
        const values = flatFilters.attributes![attributeId]
        return Object.keys(values)
          .filter(valueId => parseInt(values[valueId], 10) > 0)
          .map(valueId => `${attributeId}_${valueId}`)
      })
      .reduce((prevValue, currValue) => prevValue.concat(currValue), [])
    flatFilters.attributes = newFilters
  }
  return flatFilters
}

export const putRangeFilter = (
  rangeFilters: ActiveFiltersInterface,
  name: string,
  min: string | null,
  max: string | null,
  extraParams?: object,
) => {
  if (!_.has(AVAILABLE_FILTERS, name)) {
    return rangeFilters
  }

  const minNumber = min != null ? new BigNumber(Math.max(Number(min), 0)) : null
  const maxNumber = max != null ? new BigNumber(Math.max(Number(max), 0)) : null
  const range: {
    min?: BigNumber
    max?: BigNumber
  } = {}
  const finalRange: {
    min?: string
    max?: string
  } = {}

  if (minNumber !== null && !minNumber.isNaN()) {
    range.min = minNumber
  }

  if (maxNumber !== null && !maxNumber.isNaN()) {
    range.max = maxNumber
  }

  if (range.min != null && range.max != null && range.min.isGreaterThan(range.max) && range.max.isGreaterThan(0)) {
    range.max = [range.min, (range.min = range.max)][0]
  }

  if (range.min != null) {
    finalRange.min = range.min.toFixed(2)
  }

  if (range.max != null) {
    finalRange.max = range.max.toFixed(2)
  }

  rangeFilters[name] = finalRange
  if (extraParams) {
    rangeFilters[name] = { ...rangeFilters[name], ...extraParams }
  }
  return rangeFilters
}

export const putFlatAttribute = (flatAttributeFilters: ActiveFiltersInterface, _name: string, valueId: number | string, add?: boolean) => {
  const name = _name === FILTER_FLAT.SIZES ? 'sizeKeys' : _name

  if (!_.has(AVAILABLE_FILTERS, name)) {
    return flatAttributeFilters
  }
  if (!_.has(flatAttributeFilters, name)) {
    flatAttributeFilters[name] = []
  }
  if (add) {
    flatAttributeFilters[name].push(valueId)
    flatAttributeFilters[name] = _.uniq(flatAttributeFilters[name])
  } else {
    flatAttributeFilters[name] = flatAttributeFilters[name].filter((itemId: number | string) => itemId != valueId)
  }
  return flatAttributeFilters
}

export const putAttribute = (attributeFilters: ActiveFiltersInterface, attributeId: number, valueId: number, checked: boolean) => {
  if (!_.has(attributeFilters, 'attributes')) {
    attributeFilters['attributes'] = {}
  }
  if (!_.has(attributeFilters['attributes'], attributeId)) {
    attributeFilters.attributes![attributeId] = {}
  }
  if (checked) {
    attributeFilters.attributes![attributeId][valueId] = 1
  } else if (_.has(attributeFilters, `attributes.${attributeId}.${valueId}`)) {
    delete attributeFilters.attributes![attributeId][valueId]
  }
  return attributeFilters
}

export const hasActiveFilters = (filters: ActiveFiltersInterface) => Object.entries(filters).length > 0
